import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import '../../sass/pages/home.scss'

function LogoutButton() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return <button  
          className="logout-btn" onClick={handleLogout}>Logout</button>;
}

export default LogoutButton;
